/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Pipeline_Trigger_HintInputs */

const cs_field_pipeline_trigger_hint = /** @type {(inputs: Field_Pipeline_Trigger_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit jen při pohybu v tomto pipeline.`)
};

const en_field_pipeline_trigger_hint = /** @type {(inputs: Field_Pipeline_Trigger_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run only when the deal or task moves within this pipeline.`)
};

/**
* | output |
* | --- |
* | "Run only when the deal or task moves within this pipeline." |
*
* @param {Field_Pipeline_Trigger_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_pipeline_trigger_hint = /** @type {((inputs?: Field_Pipeline_Trigger_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Pipeline_Trigger_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_pipeline_trigger_hint(inputs)
	return cs_field_pipeline_trigger_hint(inputs)
});